// =============================================================
// Blue palette for the Training Institute admin analytics
// dashboard. Centralised here so every chart on the page shares
// the same blue identity and we never end up with random colours.
// =============================================================

export const BLUE_PALETTE = {
  // 5-step ramp from light to deep blue, used for series in stacked
  // / grouped / multi-line charts so the bands read as a single
  // brand but stay visually distinct.
  ramp: [
    '#dbeafe', // blue-100
    '#93c5fd', // blue-300
    '#3b82f6', // blue-500
    '#1d4ed8', // blue-700
    '#1e3a8a', // blue-900
  ],
  // Single-hue tints for the primary accent (lines, bars, donuts).
  primary:    '#3b82f6',  // blue-500
  primaryDark:'#1d4ed8',  // blue-700
  primaryDeeper: '#1e3a8a', // blue-900
  accent:     '#60a5fa',  // blue-400 (slightly lighter for highlights)
  // Status colours kept on a blue family so the page reads as a
  // single theme. Present = bright, absent = light grey-blue, etc.
  present:    '#10b981',  // emerald-500 (only the green we keep for "good")
  absent:     '#94a3b8',  // slate-400
  leave:      '#3b82f6',  // blue-500
  late:       '#f59e0b',  // amber-500
  permission: '#8b5cf6',  // violet-500
  // Backgrounds
  pageBg:     'linear-gradient(135deg, #eff6ff 0%, #dbeafe 50%, #bfdbfe 100%)',
  cardBg:     'rgba(255, 255, 255, 0.6)',
};

// Convenience getter — returns the i-th step of the blue ramp,
// wrapping around for series with more entries than the palette.
export const blueRamp = (i) => BLUE_PALETTE.ramp[i % BLUE_PALETTE.ramp.length];
